import { FieldError } from 'react-hook-form';

import { useFormContext } from 'core/states';

import {
  CorporateLocationAutocomplete,
  ICorporateLocationAutocompleteProps,
} from './CorporateLocationAutocomplete';

interface IProps extends ICorporateLocationAutocompleteProps {
  hidden?: boolean;
}

export const CorporateLocationFormField = ({
  name,
  hidden = false,
  disableClearable = true,
  required = false,
  ...rest
}: IProps) => {
  const { control, errors } = useFormContext();

  if (hidden) {
    return null;
  }

  return (
    <CorporateLocationAutocomplete
      name={name}
      control={control}
      error={errors?.[name] as unknown as FieldError}
      disableClearable={disableClearable}
      required={required}
      {...rest}
    />
  );
};
